import Mustache from 'mustache';

/* const fetchTempalate = async (name) => {
    let template = '';
    await fetch("./templates/" + name)
      .then((response) => response.text())
      .then((temp) => {
          template = temp;});
    return template;
} */
  //The render func determines whether the template is an expternal mustache file or a string
const render = (target, method, template, view) => {
    if (method === "innerHTML" || method === "textContent" || method === "appendTemplate") {
        //if (template.endsWith(".mustache")) {
            //template = await fetchTempalate(template);
            if (method === "appendTemplate") target.innerHTML =  target.innerHTML + Mustache.render(template, view);
            else target[method] = Mustache.render(template, view);
        // } else {
        //     if (method === "appendTemplate") target.innerHTML =  target.innerHTML + Mustache.render(template, view);
        //     else target[method] = Mustache.render(template, view);
        // }
    } else throw "Method Unknown: The function only accepts innerHTML or textContent as method of rendering!!"
}

export default render;